import { Http } from 'vrlcm-gui-utils';
import { FipsData } from 'vrlcm-gui-types';
import { LockerApiUri } from './uri';

export class SecurityApi {
  public static async getFipsData() {
    const res = await Http.get<FipsData>(LockerApiUri.Security.FIPS_DATA_URL);
    return res.data;
  }

  public static async updateFipsData(body: { enabled: boolean }) {
    const res = await Http.post<FipsData>(
      LockerApiUri.Security.FIPS_DATA_URL,
      body
    );
    return res.data;
  }
}
